import { useEffect } from 'react';
import noop from 'utils/shared/noop';

interface LoadScriptParams {
  body: string;
  onLoad?: (loadObject?: any) => void;
  onError?: () => void;
}

const useInlineScript = ({ body, onLoad = noop, onError = noop }: LoadScriptParams) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = body;
    document.getElementsByTagName('body')[0].appendChild(script);

    script.onload = (loadObject) => {
      onLoad(loadObject);
    };
    script.onerror = onError;
  }, []);
};

export default useInlineScript;
